
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { getHardwareHourlyPrice, RD_ADMIN_PERMISSION_LABEL } from '@run-diffusion/shared';
import CircleIcon from '@/components/base/CircleIcon.vue';
import AccountSelectionMenuOrBottomSheet from '@/components/AccountSelectionMenuOrBottomSheet.vue';
import HardwareOfferPriceInTokens from '@/components/HardwareOfferPriceInTokens.vue';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';
import { PRIVATE_STORAGE_CAP_BYTES, SHARED_STORAGE_CAP_BYTES } from '@/components/StorageCapCard/utils';
import { ROUTER } from '@/router/constants';
import { TeamUserMixin } from '@/mixins';
import _isEmpty from 'lodash/isEmpty';

export default Vue.extend({
	name: 'FullSelectionPreviewCard',
	mixins: [
		TeamUserMixin,
	],
	props: {
		disabled: { type: Boolean, default: false },
		appOffer: { type: Object, default: null },
		hardwareOffer: { type: Object, default: null },
		softwareOffer: { type: Object, default: null },
		deploymentImage: { type: Object, default: null },
		runnitsOwnerSelection: { type: String, default: null },
		workspaceId: { type: String, default: null },
		hideSessionType: { type: Boolean, default: null },
	},
	data () {
		return {
			ROUTER,
			RD_ADMIN_PERMISSION_LABEL,
			RUNNITS_OWNER_SELECTION,
			SHARED_STORAGE_CAP_BYTES,
			PRIVATE_STORAGE_CAP_BYTES,
			showAccountMenu: false,
		};
	},
	computed: {
		...mapState([
			'team',
			'user',
			'workspacesMap',
			'runnitState',
		]),
		...mapGetters([
			'displayLabels',
			'userClubOfferBenefits',
			'mobiusEnabled',
		]),
		canUseMobius (): boolean {
			return !!this.user;
		},
		hasSoftwareSelection (): boolean {
			return this.mobiusEnabled ? !!this.deploymentImage : !!this.softwareOffer;
		},
		selectedSoftwareLabel (): string {
			if (this.mobiusEnabled) {
				return (this.deploymentImage && this.deploymentImage.label) || '';
			}
			return (this.softwareOffer && this.softwareOffer.label) || '';
		},
		currRunnitsOwnerSelection () {
			// Prefer prop if provided (for static cases), otherwise use Vuex state
			if (this.runnitsOwnerSelection) {
				return this.runnitsOwnerSelection;
			}
			return (this.runnitState && this.runnitState.runnitsOwnerSelection) || RUNNITS_OWNER_SELECTION.USER;
		},
		runnitsOwnerSelectionHtml () {
			if (this.currRunnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM) {
				return `<div>${this.displayLabels.team} Session - <span class="gradient-text" style="font-family: var(--nasa)">${this.team?.name}</span></div>`;
			}
			return `<div>Personal Session${this.userClubOfferBenefits.isCc ? ` - <span class="gradient-text">Creator's Club</span>` : ''}</div>`;
		},
		hourlyPriceInCents (): number {
			if (!this.hardwareOffer) return 0;
			return this.getHardwareHourlyPrice(
				this.hardwareOffer,
				this.currRunnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM && this.team && this.team.isActive ? this.team.id : null,
				this.user?.club
			);
		},
	},
	methods: {
		...mapActions([
			'setMobiusEnabled',
		]),
		_isEmpty,
		getHardwareHourlyPrice,
	},
	components: {
		HardwareOfferPriceInTokens,
		CircleIcon,
		AccountSelectionMenuOrBottomSheet,
	},
});
